import React, { useState, useContext, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { FaEye, FaTrash, FaRegEdit } from 'react-icons/fa';
import {
  Box,
  IconButton,
  Snackbar,
  Alert,
  Menu,
  MenuItem,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { AuthContext } from '../../auth/ContextAuthentication';
import Button from '@mui/material/Button';

import CircleLoader from '../CircleLoader';
import { ErrorLoadingContext } from '../../auth/ErrorLoadingContext';
import GroundSettlePaymentModal from './GroundSettlePaymentModal';
import GroundFeildViewModal from './GroundFeildViewModal';
import { useNavigate } from 'react-router-dom';

const GroundSettllementTable = ({ headerData, fetchGroundData }) => {
  const { groundData } = useContext(AuthContext);
  const [addStatus, setAddStatus] = useState(null);

  const [selectedGround, setSelectedGround] = useState(null);
  const [isSettleModalOpen, setIsSettleModalOpen] = useState(false);
  const [isfeildModalOpen, setIsFeildModalOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);

  const handleMenuOpen = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(rowId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const { loading } = useContext(ErrorLoadingContext);
  const navigate = useNavigate();

  const handleViewClick = (ground) => {
    setSelectedGround(ground);
    setIsFeildModalOpen(true);
  };

  const handleSettleClick = (itemId) => {
    setSelectedGround(itemId);
    setIsSettleModalOpen(true);
  };

  const handleCloseSettleModal = () => {
    setSelectedGround(null);
    setIsSettleModalOpen(false);
  };

  const handleCheckBookings = (ground) => {
    navigate('/sportsbookings', { state: { ground } });
  };

  return (
    <>
      {addStatus !== null && (
        <Box>
          <Snackbar
            open={true}
            autoHideDuration={5000}
            onClose={() => setAddStatus(null)}
          >
            <Alert
              severity={addStatus.success ? 'success' : 'error'}
              onClose={() => setAddStatus(null)}
            >
              {addStatus.message}
            </Alert>
          </Snackbar>
        </Box>
      )}
      <TableContainer
        component={Paper}
        sx={{
          maxWidth: {
            sm: '98%',
            // md: "80%",
          },
          minWidth: {
            sm: '500px',
          },
          maxHeight: {
            md: '76vh',
            sm: '90vh',
          },
          overflowY: 'auto',
          overflowX: 'scroll',
          // position: "relative",
          top: '4rem',
          marginX: 'auto',
        }}
      >
        <Table aria-label='simple table'>
          <TableHead
            sx={{
              position: 'sticky',
              top: 0,
              backgroundColor: '#ffff',
              zIndex: '1',
            }}
          >
            <TableRow>
              {headerData.map((header, index) => (
                <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                  {header}
                </TableCell>
              ))}

              <TableCell align='center' sx={{ fontWeight: 'bold' }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={headerData.length + 1} align='center'>
                  <CircleLoader />
                </TableCell>
              </TableRow>
            ) : (
              groundData.map((data) => (
                <TableRow
                  key={data._id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component='th' scope='row'>
                    {data.name}
                  </TableCell>
                  <TableCell align='left'>{data.groundWallet || 0}</TableCell>
                  <TableCell align='left'>{data.amountSettled || 0}</TableCell>
                  <TableCell align='left'>{data.managedBy}</TableCell>
                  <TableCell align='left'>{data.totalBookings}</TableCell>
                  <TableCell align='left'>{data.totalPaidAmount}</TableCell>
                  {/* <TableCell align="left">{data.city}</TableCell> */}

                  <TableCell align='center'>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '5px',
                      }}
                    >
                      <IconButton onClick={(e) => handleMenuOpen(e, data._id)}>
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={menuRowId === data._id}
                        onClose={handleMenuClose}
                      >
                        <MenuItem
                          onClick={() => {
                            handleViewClick(data);
                            handleMenuClose();
                          }}
                        >
                          {/* <FaEye style={{ marginRight: 8, color: 'green' }} />{' '} */}
                          View Fields Rates
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleSettleClick(data);
                            handleMenuClose();
                          }}
                        >
                          Settle Payment
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleCheckBookings(data);
                            handleMenuClose();
                          }}
                        >
                          Check Bookings
                        </MenuItem>
                      </Menu>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
            {groundData.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align='center'>
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <GroundSettlePaymentModal
        isSettleModalOpen={isSettleModalOpen}
        handleRefetch={fetchGroundData}
        handleCloseSettleModal={handleCloseSettleModal}
        selectedGround={selectedGround}
      />
      <GroundFeildViewModal
        isfeildModalOpen={isfeildModalOpen}
        handleclose={() => {
          setIsFeildModalOpen(false);
          setSelectedGround(null);
        }}
        selectedGround={selectedGround}
      />
    </>
  );
};

export default GroundSettllementTable;
